export default {
  submitText: '结算',
  emptyBtn: false,
  submitDisabled:true,
  submitBtn:false,
  group: [
    {
      label: '房间租户信息',
      prop: 'group1',
      column: [
        {
          label: '入住房间',
          type: 'tree',
          prop: 'departmentId',
          dicUrl: '/api/v4ward/department/getDepartmentByPropertyNameTree',
          props: {
            label: 'propertyName',
            value: 'id',
          },
          disabled: true,
        },
        {
          label: '室友',
          prop: 'roommateName',
          disabled: true,
        },
        {
          label: '房租租金',
          type: 'number',
          precision: '2',
          prop: 'rentAmount',
          disabled: true,
        },
        {
          label: '减免金额',
          type: 'number',
          prop: 'derateMoney',
          disabled: true,
        },
        {
          label: '押金金额',
          type: 'number',
          prop: 'deposit',
          disabled: true,
        },
        {
          label: '押金编号',
          prop: 'depositNo',
          disabled: true,
        },
      ],
    },
    {
      label: '退租信息   (计算金额后可根据实际情况调整)',
      prop: 'group3',
      column: [
        {
          label: '电费止码',
          type: 'number',
          precision: '2',
          prop: 'electricityEedNum',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
            {
              required: true,
              message: '请输入电费止码',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '水费止码',
          type: 'number',
          precision: '2',
          prop: 'waterEedNumber',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },

        {
          label: '退租时间',
          prop: 'endDate',
          type: 'datetime',
          dataType: 'Sting',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          rules: [
            {
              required: true,
              message: '请选择退租时间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '',
          prop: 'bind',
          labelslot: true,
          formslot:true
        }
      ],
    },
    {
      label: '账单信息',
      prop: 'group2',
      column: [
        {
          label: '电费金额',
          type: 'number',
          precision: '2',
          prop: 'electricityAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '水费金额',
          type: 'number',
          precision: '2',
          prop: 'waterAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '公摊电费',
          type: 'number',
          precision: '2',
          prop: 'meanElectricityAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '公摊水费',
          type: 'number',
          precision: '2',
          prop: 'meanWaterAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '卫生费',
          type: 'number',
          precision: '2',
          prop: 'meanHealthAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '物业费',
          type: 'number',
          precision: '2',
          prop: 'propertyFeeAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '房租费',
          type: 'number',
          precision: '2',
          prop: 'meanRentAmount',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '应缴金额',
          type: 'number',
          precision: '2',
          prop: 'shouldAmount',
          disabled: true,
        },
        {
          label: '支付方式',
          prop: 'payWay',
          width: 50,
          type: 'select',
          props: {
            label: 'dictValue',
            value: 'dictKey',
          },
          dicUrl: '/api/blade-system/dict/dictionary?code=pay_way',
          rules: [
            {
              required: true,
              message: '请选择支付方式',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
  ],
};
